import React, { useState } from 'react';
import { Link, Box, Button, SvgIcon } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import '../../common/theme/UserFlowPage.scss';
import './UserType.scss';
import '../../common/theme/AmigCustomTheme.scss';

const UserTypeComponent = ({
  handleSelectUserType,
  handlePrevStep,
  selectedUserType
}) => {
  const [userTypeRadioBtn, setUserTypeRadioBtn] = useState(selectedUserType);
  const [disabled, setDisabled] = useState(true);

  const handleChange = (event) => {
    setUserTypeRadioBtn(event.target.value);
    setDisabled(false);
  };

  return (
    <>
      <div className='userTypeSelection agent-ciam-container'>
        <div className='userType-container'>
          <div className='eyebrow'>
            Create an account: User type
          </div>
          <div className='title'>
            Select user type
          </div>
          <p className='amig-body2-web-regular'>
            Please select one and press continue.
          </p>
          <form className='userType amig-body2-web-bold' >
            <div className="radiogroup" value={userTypeRadioBtn}>
              <label className={userTypeRadioBtn === "licensed" ? "selected" : ""}>
                <input type="radio" className="radio" name="userSelectType" value="licensed" onChange={handleChange} checked={userTypeRadioBtn === "licensed"} />
                <span>Licensed agent</span>
              </label>
              <label className={userTypeRadioBtn === "non-licensed" ? "selected" : ""}>
                <input type="radio" className="radio" name="userSelectType" value="non-licensed" onChange={handleChange} checked={userTypeRadioBtn === "non-licensed"} />
                <span>Non-licensed agent</span>
              </label>
            </div>
            <div>
              <p className='amig-body2-web-regular'>
                Not sure? We recommend choosing Non-licensed agent.
            </p>
            </div>
          </form>
        </div>
      </div>
      <Box className='buttonsBox'>
        <div>
          <Button
            disableRipple
            disabled={(disabled && userTypeRadioBtn === undefined) || (userTypeRadioBtn === null ? true : false)}
            className='button-styling continue-button'
            onClick={() => handleSelectUserType(userTypeRadioBtn)}
            aria-disabled={(disabled && userTypeRadioBtn === undefined) || (userTypeRadioBtn === null ? true : false)}
          >
            Continue
          </Button>
        </div>
        <div>
          <Button
            disableRipple
            component={Link}
            color='primary'
            onClick={() => {
              handlePrevStep('welcome');
            }}
            className='back-button'
            to='/userType'
          >
            <SvgIcon
              className='back-arrow'
              component={ArrowBackIosIcon}
            />
            <span>Back</span>
          </Button>
        </div>
      </Box>
    </>
  );
};

export default UserTypeComponent;
